<template>
    <div class="orders-create">
        <b-modal
            :active.sync="assetsModal.active"
            :width="'90vw'"
            :height="'80vw'"
            has-modal-card
        >
            <order-operations-modal
                :order="transformedData()"
                :address="place"
                :operation="asset ? { asset } : null"
                :operation-code-ids="getOrderCodeIds('ASSET')"
                has-select-location
                :location="orderLocation"
                @select="onAssetModalSelect"
                @select-location="onAssetModalSelectLocation"
                @select-location-asset="onAssetModalSelectLocationAsset"
            ></order-operations-modal>
        </b-modal>

        <div class="columns" style="background-color: #777; margin: 0">
            <div class="column is-6">
                <div id="create-order-form" class="card form">
                    <header class="card-header has-background-dark is-size-6">
                        <p class="card-header-title has-text-light">
                            {{ cardTitle }}
                        </p>
                        <p
                            v-if="order"
                            class="card-header-title has-text-light"
                            style="justify-content: end"
                        >
                            {{ order.orderId }}
                        </p>
                    </header>

                    <div class="card-content scrollable is-relative">
                        <!-- Order ID Field -->
                        <!--
                        <div class="field is-horizontal">
                            <div class="field-label">
                                <label class="label">Order ID</label>
                            </div>
                            <div class="field-body">
                                <b-field>
                                <b-input name="order_id" v-model="form.orderId" size="is-small"></b-input>
                                </b-field>
                            </div>
                        </div>
                        -->

                        <!-- Contracts -->
                        <div
                            v-show="
                                !routeIsLoading && contractsGiven.length > 1
                            "
                            class="field is-horizontal"
                        >
                            <div class="field-label">
                                <label class="label">Contract</label>
                            </div>
                            <div class="field-body">
                                <b-select
                                    id="contract_id"
                                    name="contract"
                                    size="is-small"
                                    :disabled="routeIsLoading"
                                    :loading="routeIsLoading"
                                    v-model="form.contract_id"
                                    expanded
                                >
                                    <option value="">Please Select</option>
                                    <option
                                        v-for="contract in contractsGiven"
                                        :value="contract.id"
                                        :key="contract.id"
                                    >
                                        {{ `${contract.contractor.name} -
                                        ${contract.name}` }}
                                    </option>
                                </b-select>
                            </div>
                        </div>

                        <!-- Issued By Fields -->
                        <!-- v-if="false"" while transitioning to contracts -->
                        <div v-if="false" class="field is-horizontal">
                            <div class="field-label">
                                <label class="label">Issued By</label>
                            </div>
                            <div class="field-body">
                                <b-field>
                                    <base-select
                                        name="issued_by"
                                        ref="issuedBy"
                                        :service="firmService"
                                        fetch-func="parents"
                                        :fetch-params="{
                                            permissions: ['can issue orders'],
                                        }"
                                        value-key="id"
                                        label-key="name"
                                        label
                                        :small="true"
                                        :value.sync="form.issuingOrganization"
                                        preselect-on-one
                                    ></base-select>
                                </b-field>
                            </div>
                        </div>

                        <!-- Manage By Fields -->
                        <div class="field is-horizontal">
                            <div class="field-label">
                                <label class="label">Manage By</label>
                            </div>
                            <div class="field-body">
                                <b-field>
                                    <b-select
                                        size="is-small"
                                        :disabled="
                                            !form.issuingOrganization ||
                                            !userFirmMatched
                                        "
                                        v-model="form.manager"
                                        expanded
                                    >
                                        <option value="">Please Select</option>
                                        <option
                                            v-for="option in manager"
                                            :value="option.id"
                                            :key="option.id"
                                        >
                                            {{ option.fullName }}
                                        </option>
                                    </b-select>
                                </b-field>
                            </div>
                        </div>

                        <!-- Issued To Fields -->
                        <!-- v-if="false" while transitioning to contracts -->
                        <div v-if="false" class="field is-horizontal">
                            <div class="field-label">
                                <label class="label">Issued To</label>
                            </div>
                            <div class="field-body">
                                <b-field>
                                    <base-select
                                        name="issued_to"
                                        ref="issuedTo"
                                        label
                                        :service="firmService"
                                        fetch-func="children"
                                        :fetch-params="{
                                            firm_id:
                                                form.issuingOrganization ||
                                                undefined,
                                            firm_firm_permissions: [
                                                'can be issued orders',
                                            ],
                                        }"
                                        value-key="id"
                                        label-key="name"
                                        :small="true"
                                        :value.sync="form.contractor"
                                        preselect-on-one
                                        @fetch="(v) => (issuedToFirms = v)"
                                    ></base-select>
                                </b-field>
                            </div>
                        </div>

                        <!-- Order Type Fields -->
                        <div class="field is-horizontal">
                            <div class="field-label">
                                <label class="label">Order Type</label>
                            </div>
                            <div class="field-body">
                                <b-field>
                                    <b-select
                                        name="order_type"
                                        class="order-type"
                                        v-model="form.orderType"
                                        size="is-small"
                                        expanded
                                        :disabled="codesBusy"
                                        :loading="codesBusy"
                                    >
                                        <option value>Please select</option>
                                        <option
                                            v-for="code in orderTypes"
                                            :key="`order_type_${code.id}`"
                                            :value="code.id"
                                        >
                                            {{ code.name }}
                                        </option>
                                    </b-select>
                                </b-field>
                            </div>
                        </div>

                        <!-- Sub Type Fields -->
                        <div class="field is-horizontal">
                            <div class="field-label">
                                <label class="label">Sub Type</label>
                            </div>
                            <div class="field-body">
                                <b-field>
                                    <b-select
                                        name="sub_type"
                                        class="sub-type"
                                        v-model="form.subType"
                                        size="is-small"
                                        expanded
                                        :disabled="codesBusy"
                                        :loading="codesBusy"
                                    >
                                        <option value>Please select</option>
                                        <option
                                            v-for="code in activityTypes"
                                            :value="code.id"
                                            :key="code.code"
                                        >
                                            {{ getActivityTypeText(code) }}
                                        </option>
                                    </b-select>
                                </b-field>
                            </div>
                        </div>

                        <!-- Problem Code Field -->
                        <div class="field is-horizontal">
                            <div class="field-label">
                                <label class="label">Problem Code</label>
                            </div>
                            <div class="field-body">
                                <template v-if="problemCodes.length">
                                    <b-field>
                                        <b-select
                                            name="assigned_to"
                                            v-model="form.problemCode"
                                            size="is-small"
                                            expanded
                                            :disabled="codesBusy"
                                            :loading="codesBusy"
                                        >
                                            <option value>Please select</option>
                                            <option
                                                v-for="code in problemCodes"
                                                :value="code.id"
                                                :key="code.id"
                                            >
                                                {{ code.name }}
                                            </option>
                                        </b-select>
                                    </b-field>
                                </template>
                                <template v-else>
                                    <b-field>
                                        <b-select
                                            name="assigned_to"
                                            v-model="form.problemCode"
                                            size="is-small"
                                            expanded
                                            :disabled="true"
                                        >
                                            <option value>
                                                Not Applicable
                                            </option>
                                        </b-select>
                                    </b-field>
                                </template>
                            </div>
                        </div>

                        <!-- Priority Field  -->
                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <label class="label">Priority</label>
                            </div>
                            <div class="field-body">
                                <b-field>
                                    <b-select
                                        expanded
                                        size="is-small"
                                        name="priority"
                                        v-model="form.priority"
                                        :loading="
                                            codesBusy || codesBusyPriority
                                        "
                                        :disabled="
                                            codesBusy ||
                                            codesBusyPriority ||
                                            !form.orderType ||
                                            !form.subType
                                        "
                                    >
                                        <option value>Please select</option>
                                        <option
                                            v-for="code in orderPriorities"
                                            :key="code.code"
                                            :value="code.id"
                                        >
                                            {{ code.name }}
                                        </option>
                                    </b-select>
                                </b-field>
                            </div>
                        </div>

                        <!-- Region Field -->
                        <div
                            class="field is-horizontal"
                            v-show="
                                $refs.selectTags
                                    ? $refs.selectTags.options.length
                                    : true
                            "
                        >
                            <div class="field-label">
                                <label class="label">Tag</label>
                            </div>
                            <div class="field-body">
                                <base-select
                                    name="region"
                                    label
                                    v-model="form.region"
                                    :service="tagService"
                                    fetch-func="all"
                                    :fetch-params="{
                                        type: '[ORDER][MANDATORY]',
                                        firm_id:
                                            form.issuingOrganization ||
                                            user.firmId,
                                    }"
                                    value-key="id"
                                    label-key="name"
                                    :small="true"
                                    :type="region_error ? 'is-danger' : ''"
                                    :message="
                                        region_error
                                            ? 'This field is required'
                                            : ''
                                    "
                                    ref="selectTags"
                                ></base-select>
                            </div>
                        </div>

                        <!-- Expected Start -->
                        <b-field
                            label="Expected Start"
                            :message="
                                serviceLevel
                                    ? `Added ${serviceLevel.hours_to_start} Hour/s`
                                    : 'No Service Level Found'
                            "
                            horizontal
                        >
                            <b-datetimepicker
                                placeholder="Select date"
                                size="is-small"
                                icon="calendar"
                                v-model="form.expectedStart"
                            >
                            </b-datetimepicker>
                        </b-field>

                        <!-- Expected Finish -->
                        <b-field
                            label="Expected Finish"
                            :message="
                                serviceLevel
                                    ? `Added ${serviceLevel.hours_to_finish} Hour/s`
                                    : 'No Service Level Found'
                            "
                            horizontal
                        >
                            <b-datetimepicker
                                placeholder="Select date"
                                size="is-small"
                                icon="calendar"
                                v-model="form.expectedFinish"
                            >
                            </b-datetimepicker>
                        </b-field>

                        <!-- Search Addres Field -->
                        <!--
                        <div class="field is-horizontal">
                            <div class="field-label">
                                <label class="label">Search Address</label>
                            </div>
                            <div class="field-body">
                                <b-field>
                                <div class="control is-clearfix is-expanded">

                                    <vue-google-autocomplete
                                        id="address-autocomplete"
                                        ref="addressAutoComplete"
                                        class="input is-small"
                                        placeholder
                                        :country="['nz']"
                                        v-on:placechanged="getAddressData"
                                        v-on:locationSelect="sample"
                                    ></vue-google-autocomplete>

                                </div>
                                <p class="control">
                                    <button
                                    id="gps_locator"
                                    class="button is-small"
                                    @click.prevent="getGPSLocation"
                                    >
                                    Use GPS Location
                                    </button>
                                </p>
                                </b-field>
                            </div>
                        </div>
                        -->

                        <div class="field is-horizontal">
                            <div class="field-label">
                                <label class="label">Location/Site</label>
                            </div>
                            <div class="field-body">
                                <!--
                                <b-field>
                                    <b-input
                                        :value="locationAsset ? (locationAsset.assetName || locationAsset.thirdPartyCode) : ''"
                                        disabled
                                    ></b-input>
                                </b-field>
                                -->
                                <base-select
                                    label
                                    v-model="form.location_asset_id"
                                    :service="assetService"
                                    fetch-func="all"
                                    :fetch-params="{
                                        code_code: 'SITE',
                                        contract_ids: [form.contract_id],
                                    }"
                                    :fetch-on-init="false"
                                    :disabled="!form.contract_id"
                                    :small="true"
                                    ref="selectLocationAsset"
                                >
                                    <template #customLabel="{ option }">
                                        {{ `${option.assetName ||
                                        option.thirdPartyCode}` }}
                                    </template>
                                </base-select>
                            </div>
                        </div>

                        <div class="field is-horizontal">
                            <div class="field-label">
                                <label class="label">Address</label>
                            </div>
                            <div class="field-body">
                                <b-field
                                    :type="asset_error ? 'is-danger' : ''"
                                    :message="
                                        asset_error
                                            ? 'Please select an Asset'
                                            : ''
                                    "
                                >
                                    <div
                                        class="control is-clearfix is-expanded"
                                    >
                                        <b-input
                                            size="is-small"
                                            :value="form.address"
                                            placeholder="Pick Location/Site above, or click SELECT to search with map..."
                                            expanded
                                            disabled
                                        ></b-input>
                                    </div>
                                    <p class="control">
                                        <b-button
                                            id="btn-select-asset"
                                            size="is-small"
                                            @click="assetsModal.active = true"
                                            :disabled="!form.contract_id"
                                            >SELECT</b-button
                                        >
                                    </p>
                                </b-field>
                            </div>
                        </div>

                        <!-- Address Field -->
                        <div class="field is-horizontal">
                            <div class="field-label">
                                <label class="label"></label>
                            </div>
                            <div class="field-body">
                                <b-field>
                                    <b-input
                                        name="address"
                                        v-model="form.address"
                                        type="textarea"
                                        :disabled="parentOrder"
                                    ></b-input>
                                </b-field>
                            </div>
                        </div>

                        <!-- Work Description Field -->
                        <div class="field is-horizontal">
                            <div class="field-label">
                                <label class="label">Work Description</label>
                            </div>
                            <div class="field-body">
                                <b-field>
                                    <b-input
                                        name="work_description"
                                        v-model="form.workDescription"
                                        type="textarea"
                                    ></b-input>
                                </b-field>
                            </div>
                        </div>

                        <!-- Activity Type Fields -->
                        <div class="field is-horizontal">
                            <div class="field-label">
                                <label class="label">Activity Type</label>
                            </div>
                            <div class="field-body">
                                <b-field>
                                    <base-select
                                        name="activity_type"
                                        size="is-small"
                                        :value.sync="activityTypeId"
                                        :service="codeService"
                                        fetch-func="chained"
                                        :fetch-params="{
                                            ids: getOrderCodeIds('ACTIVITY'),
                                            type: 'ACTIVITY',
                                            contract_id: form.contract_id,
                                        }"
                                        @options-updated="
                                            onActivityTypeOptionsUpdated
                                        "
                                        :fetch-on-init="false"
                                        ref="activityTypeId"
                                        :small="true"
                                        :type="
                                            activity_type_error
                                                ? 'is-danger'
                                                : ''
                                        "
                                        :message="
                                            activity_type_error
                                                ? 'This field is required'
                                                : ''
                                        "
                                        :disabled="activityTypeIsDisabled"
                                        label
                                        preselect-on-one
                                    ></base-select>
                                </b-field>
                            </div>
                        </div>

                        <!-- Activity Owner Fields -->
                        <div class="field is-horizontal">
                            <div class="field-label">
                                <label class="label">Activity Owner</label>
                            </div>
                            <div class="field-body">
                                <b-field>
                                    <!--
                                    <base-select
                                        name="activityOwner"
                                        size="is-small"
                                        :value.sync="activityOwnerId"
                                        :service="firmService"
                                        fetch-func="all"
                                        :fetch-params="{ activityOwner: 1 }"
                                        :small="true"
                                        label
                                    ></base-select>
                                    -->
                                    <base-select
                                        name="activityOwner"
                                        :value.sync="activityOwnerId"
                                        value-key="firm.id"
                                        label-key="firm.name"
                                        :service="firmService"
                                        fetch-func="childFirmAssociations"
                                        :fetch-params="{
                                            firm_id: form.issuingOrganization,
                                            tags: ['CUSTOMER'],
                                            includes: 'firm',
                                        }"
                                        :fetch-on-init="false"
                                        :small="true"
                                        :disabled="!form.issuingOrganization"
                                        ref="selectActivityOwner"
                                    ></base-select>
                                </b-field>
                            </div>
                        </div>

                        <!-- Asset Type Fields -->
                        <div class="field is-horizontal" v-show="asset">
                            <div class="field-label">
                                <label class="label">Asset Type</label>
                            </div>
                            <div class="field-body">
                                <b-field>
                                    <b-input
                                        :value="
                                            asset && asset.code
                                                ? asset.code.name
                                                : ''
                                        "
                                        size="is-small"
                                        expanded
                                        disabled
                                    ></b-input>
                                    <!--
                                    <base-select
                                        name="asset_type"
                                        size="is-small"
                                        :value.sync="assetTypeId"
                                        :service="codeService"
                                        fetch-func="chained"
                                        :fetch-params="{ ids: getOrderCodeIds('ASSET'), type: 'ASSET' }"
                                        :fetch-on-init="false"
                                        ref="assetTypeId"
                                        :small="true"
                                        label
                                        :disabled="!activityTypeParentId"
                                    ></base-select>
                                    -->
                                </b-field>
                            </div>
                        </div>

                        <!-- Asset ID Field -->
                        <div class="field is-horizontal">
                            <div class="field-label">
                                <label class="label">Asset ID</label>
                            </div>
                            <div class="field-body">
                                <b-field>
                                    <div
                                        class="control is-clearfix is-expanded"
                                    >
                                        <b-input
                                            :value="
                                                asset
                                                    ? asset.thirdPartyCode ||
                                                      asset.id
                                                    : ''
                                            "
                                            size="is-small"
                                            expanded
                                            disabled
                                        ></b-input>
                                    </div>
                                    <!--
                                        <p class="control">
                                            <b-button size="is-small" @click="assetsModal.active = true">SELECT</b-button>
                                        </p>
                                    -->
                                </b-field>
                            </div>
                        </div>

                        <!--
                        REMINDER: we use v-show instead of v-if here because we need this element
                        to be present in order to inspect its options as part of asset validation.
                        -->
                        <div class="field is-horizontal" v-show="!asset">
                            <div class="field-label">
                                <label class="label">Asset Type</label>
                            </div>
                            <div class="field-body">
                                <b-field
                                    :type="asset_type_error ? 'is-danger' : ''"
                                    :message="
                                        asset_type_error
                                            ? 'This field is required'
                                            : ''
                                    "
                                >
                                    <base-select
                                        name="asset_type"
                                        size="is-small"
                                        :value.sync="assetTypeId"
                                        :service="codeService"
                                        fetch-func="chained"
                                        :fetch-params="{
                                            ids: getOrderCodeIds('ASSET'),
                                            type: 'ASSET',
                                            contract_id: form.contract_id,
                                        }"
                                        :fetch-on-init="false"
                                        ref="assetTypeId"
                                        :small="true"
                                        label
                                        @change="(val) => (assetType = val)"
                                        :disabled="!activityTypeParentId"
                                    >
                                    </base-select>
                                </b-field>
                            </div>
                        </div>

                        <!--
                        <div class="field is-horizontal" v-else>
                            <div class="field-label">
                                <label class="label">Asset Type</label>
                            </div>
                            <div class="field-body">
                                <base-select label
                                    defaultOptionLabel="Not Applicable"
                                    :service="codeService"
                                    fetch-func="all"
                                    :fetch-params="{
                                    type: 'asset',
                                    }"
                                    value-key="id"
                                    :small="true"
                                    @input="val => onChange('assetTypeId', val)"
                                >
                                    <template #customLabel="{ option }">
                                    {{ option.name }}
                                    </template>
                                </base-select>
                            </div>
                        </div>
                        -->

                        <!-- Assign To Field -->
                        <div class="field is-horizontal">
                            <div class="field-label">
                                <label class="label">Assign To</label>
                            </div>
                            <div class="field-body">
                                <b-field v-if="form.contractor == user.firm.id">
                                    <base-select
                                        v-model="form.assignedTo"
                                        label
                                        :service="userService"
                                        fetch-func="all"
                                        :fetch-params="{
                                            firmId: user.firm.id,
                                            filter_by: 'first_name',
                                            active: 1,
                                            archived: 0,
                                        }"
                                        value-key="id"
                                        :small="true"
                                        @input="
                                            (val) => onInput('assignedTo', val)
                                        "
                                    >
                                        <template #customLabel="{ option }">
                                            {{ option.firstName }}
                                        </template>
                                    </base-select>
                                </b-field>
                                <b-field v-else>
                                    <b-select
                                        expanded
                                        placeholder="Unassigned"
                                        :disabled="true"
                                    >
                                    </b-select>
                                </b-field>
                            </div>
                        </div>

                        <!-- Reference Field -->
                        <div class="field is-horizontal">
                            <div class="field-label">
                                <label class="label">Reference</label>
                            </div>
                            <div class="field-body">
                                <b-field>
                                    <b-input
                                        v-model="form.reference"
                                        size="is-small"
                                    ></b-input>
                                </b-field>
                            </div>
                        </div>

                        <!-- Claim Period Field -->
                        <!--
                        <div class="field is-horizontal" v-if="order">
                            <div class="field-label">
                                <label class="label">Claim Period</label>
                            </div>
                            <div class="field-body">
                                <base-select
                                label
                                :service="orderService"
                                fetch-func="findClaimIds"
                                :denormalize="false"
                                value-key="value"
                                label-key="text"
                                :small="true"
                                @input="val => onInput('claimPeriod', val)"
                                ></base-select>
                            </div>
                        </div>
                        -->

                        <!-- Claim Period Field -->
                        <!--
                        <div class="field is-horizontal" v-if="order">
                            <div class="field-label">
                                <label class="label">Parent WO</label>
                            </div>
                            <div class="field-body">
                                <b-field>
                                    <b-autocomplete
                                        v-model="form.parentWO"
                                        :data="autocomplete.parentWO.data"
                                        placeholder="Search for orders..."
                                        field="orderId"
                                        size="is-small"
                                        :loading="autocomplete.parentWO.loading"
                                        @typing="query => getOrders(query, 'parentWO')"
                                    ></b-autocomplete>
                                </b-field>
                            </div>
                        </div>
                        -->

                        <!-- Claim Period Field -->
                        <!--
                        <div class="field is-horizontal" v-if="order">
                            <div class="field-label">
                                <label class="label">Duplicate WO</label>
                            </div>
                            <div class="field-body">
                                <b-field>
                                <b-autocomplete
                                    v-model="form.duplicateWO"
                                    :data="autocomplete.duplicateWO.data"
                                    placeholder="Search for orders..."
                                    field="orderId"
                                    size="is-small"
                                    :loading="autocomplete.duplicateWO.loading"
                                    @typing="query => getOrders(query, 'duplicateWO')"
                                ></b-autocomplete>
                                </b-field>
                            </div>
                        </div>
                        -->

                        <!-- Switch Field -->
                        <!--
                        <div class="field is-horizontal">
                            <div class="field-label">
                                <label class="label"></label>
                            </div>
                            <div class="field-body">
                                <div class="columns is-mobile" style="width:100%;">
                                <div class="column is-6">
                                    <b-field v-if="order">
                                    <b-switch
                                        v-model="form.onHold"
                                        :true-value="1"
                                        :false-value="0"
                                        type="is-dark"
                                        size="is-small"
                                        >On Hold</b-switch
                                    >
                                    </b-field>

                                    <b-field v-if="order">
                                    <b-switch
                                        v-model="form.furtherWorkRequired"
                                        :true-value="1"
                                        :false-value="0"
                                        type="is-dark"
                                        size="is-small"
                                        >Further Work Required</b-switch
                                    >
                                    </b-field>

                                </div>
                                <div class="column is-6">
                                    <b-field v-if="order">
                                    <b-switch
                                        v-model="form.stormEvent"
                                        :true-value="1"
                                        :false-value="0"
                                        type="is-dark"
                                        size="is-small"
                                        >Storm Event</b-switch
                                    >
                                    </b-field>

                                    <b-field v-if="order">
                                    <b-switch
                                        v-model="form.notSurveyed"
                                        :true-value="1"
                                        :false-value="0"
                                        type="is-dark"
                                        size="is-small"
                                        >Not Surveyed</b-switch
                                    >
                                    </b-field>

                                    <b-field v-if="order">
                                    <b-switch
                                        v-model="form.manholeSurcharged"
                                        :true-value="1"
                                        :false-value="0"
                                        type="is-dark"
                                        size="is-small"
                                        >Manhole Surcharged</b-switch
                                    >
                                    </b-field>
                                    </div>
                                </div>
                            </div>
                        </div>
                        -->

                        <!--
                        <div class="field is-horizontal">
                            <div class="field-label">
                                <label class="label">Select Asset</label>
                            </div>
                            <div class="field-body">
                                <b-field>
                                <b-autocomplete
                                    :data="assets"
                                    field="tags"
                                    size="is-small"
                                    placeholder="Search Asset Tag"
                                    icon="magnify"
                                    clearable
                                    @select="option => assetId = option.id">
                                    <template slot="empty">No results found</template>
                                </b-autocomplete>
                                </b-field>
                            </div>
                        </div>
                        -->
                    </div>

                    <!--
                    <footer class="card-footer">
                        <div class="buttons">
                            <b-button
                                class="is-fullwidth"
                                type="is-info"
                                size="is-small"
                                :loading="drafting"
                                @click="draft"
                                v-if="!approved"
                            >SAVE DRAFT</b-button>
                            <b-button
                                class="is-fullwidth"
                                type="is-info"
                                size="is-small"
                                :loading="submitting"
                                @click="submit"
                            >
                                {{
                                order ? (approved ? "UPDATE" : "APPROVE") : "SUBMIT"
                                }}
                            </b-button>
                        </div>
                    </footer>
                    -->

                    <footer class="card-footer has-background-light">
                        <div class="columns">
                            <div class="column is-two-fifths"></div>

                            <div class="column is-one-fifth">
                                <router-link
                                    :to="{ name: 'order-list' }"
                                    class="button is-fullwidth is-dark"
                                    >CANCEL</router-link
                                >
                                <!-- <button type="button" class="button is-fullwidth is-dark">CANCEL</button> -->
                            </div>

                            <div class="column is-one-fifth" v-if="!approved">
                                <b-button
                                    class="is-fullwidth"
                                    :loading="drafting"
                                    @click="draft"
                                    >SAVE DRAFT</b-button
                                >
                            </div>

                            <div class="column is-one-fifth">
                                <b-button
                                    id="submit_order"
                                    class="is-fullwidth"
                                    type="is-info"
                                    :loading="submitting"
                                    @click="submit"
                                >
                                    {{ order ? approved ? "UPDATE" : "SUBMIT" :
                                    "SUBMIT" }}
                                </b-button>
                            </div>
                        </div>
                    </footer>
                </div>
            </div>

            <div class="column is-6" style="padding: 0.25rem" v-if="false">
                <div class="card detail">
                    <header class="card-header has-background-dark">
                        <p
                            class="card-header-title has-text-light is-invisible"
                        >
                            <!-- PLACEHOLDER -->
                        </p>
                    </header>
                    <div class="card-content scrollable is-relative">
                        <div class="overlay" v-if="!order"></div>
                        <order-detail-tabs :order="order" :hidden="[0]" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from "moment";
    import _ from "lodash";
    import BaseSelect from "@/components/partials/BaseSelect";
    import OrderDetailTabs from "@/components/Order/OrderDetailTabs";
    import OrderOperationsModal from "@/components/Order/OrderOperationsModal";
    import { ContractService } from "@/services/contract.service";
    import { CodeService } from "@/services/code.service";
    import { FirmService } from "@/services/firm.service";
    import { OrderService } from "@/services/order.service";
    import { UserService } from "@/services/user.service";
    import { PlaceService } from "@/services/place.service";
    import { TagService } from "@/services/tag.service";
    import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
    import VueGoogleAutocomplete from "@/components/partials/VueGoogleAutocomplete";
    import { OrderOperationService } from "@/services/orderOperation.service";
    import BasicCreate from "./basic";
    import { AssetService } from "@/services/asset.service";
    import EventUtil from "@/utils/event.util.js";

    export default {
        // Trying to start using the DB for orderTypes and activityTypes
        // orderTypes: ["PLANNED", "REACTIVE"],
        // activityTypes: ["REACTIVE", "PLANNED", "MINOR CAPITAL", "PREVENTIVE"],
        priorities: [
            "HEALTH & SAFETY P1",
            "EMERGENCY P2",
            "EMERGENCY P3",
            "EMERGENCY P4",
            "ROUTINE P5",
            "PROJECTED P6",
        ],
        props: {
            parentOrder: {
                type: Object,
            },
        },
        components: {
            BaseSelect,
            OrderDetailTabs,
            OrderOperationsModal,
            VueGoogleAutocomplete,
            BasicCreate,
        },
        data: () => ({
            contracts: [],
            issuedToFirms: [],
            asset_error: false,
            region_error: false,
            activity_type_error: false,
            asset_type_error: false,
            orderOperationService: OrderOperationService,
            codeService: CodeService,
            firmService: FirmService,
            orderService: OrderService,
            userService: UserService,
            placeService: PlaceService,
            tagService: TagService,
            assetService: AssetService,
            codesBusy: false, // dependent: orderType -> activityType -> problemCode
            codesBusyPriority: false,
            orderTypes: [],
            orderPriorities: [],
            orderTypeValue: null,
            activityTypes: [],
            problemCodes: [],
            regions: [],
            order: null,
            operation: null,
            form: {
                contract_id: "",
                orderId: "",
                orderType: "",
                subType: "",
                issuingOrganization: "",
                manager: "",
                contractor: "",
                place: "",
                priority: "",
                address: "",
                location_asset_id: "",
                problemCode: "",
                workDescription: "",
                reference: "",
                claimPeriod: "",
                assignedTo: null,
                parentWO: "",
                duplicateWO: "",
                onHold: 0,
                furtherWorkRequired: 0,
                returnToSite: 0,
                stormEvent: 0,
                notSurveyed: 0,
                manholeSurcharged: 0,
                address_latitude: 0,
                address_longitude: 0,
                region: "",
            },
            autocomplete: {
                parentWO: {
                    data: [],
                    loading: false,
                    timeout: null,
                },
                duplicateWO: {
                    data: [],
                    loading: false,
                    timeout: null,
                },
            },
            serviceLevel: null,
            drafting: false,
            submitting: false,
            activityTypeId: null,
            activityTypeParentId: null,
            activityOwnerId: null,
            assetType: null,
            assetTypeId: null,
            manager: [],
            assets: [],
            assetId: null,
            asset: null,
            assetsModal: {
                active: false,
            },
            place: null,
            next_order_type: null,
            locationAsset: null,
        }),

        computed: {
            routeIsLoading() {
                return this.$store.getters["routeIsLoading"];
            },
            contractsGiven() {
                let contracts = [];
                const user = this.$store.state.Auth.user;
                contracts = this.contracts.filter((c) => {
                    // let start_code_type;
                    // let given = (user && c.contractee_firm_id == user.firmId);
                    // let given = true; // contractor contracts are now also being collected
                    // let startCodeAttribute = c.attributes.find(attr => {
                    //   return attr.code == '[SYSTEM][ORDER][CODE_CHAIN][START]';
                    // });
                    // start_code_type = startCodeAttribute ? startCodeAttribute.value : start_code_type;
                    // return (given && start_code_type && !c.archived_at);
                    return !c.archived_at;
                });
                contracts = _.sortBy(contracts, (c) => c.contractor.name);
                return contracts;
            },
            contractSelected() {
                const contract_id = this.form.contract_id;
                const contract = this.contracts.find(
                    (c) => c.id == contract_id,
                );
                return contract || null;
            },
            userFirmMatched() {
                return this.user.firmId == this.form.issuingOrganization;
            },
            canCreateBasicOrders() {
                return this.$store.getters["Auth/hasFirmPermission"](
                    "can create basic orders",
                );
            },
            user() {
                return this.$store.state.Auth.user;
            },
            cardTitle() {
                return this.order ? "UPDATE ORDER" : "CREATE ORDER";
            },
            approved() {
                return this.order && this.order.status === "APPROVED";
            },
            orderIsReactive() {
                const orderType = this.orderTypes.find(
                    (type) => type.id === this.form.orderType,
                );
                if (
                    orderType &&
                    (orderType.code == "REACTIVE" ||
                        orderType.code.toUpperCase().includes("RFS"))
                ) {
                    return true;
                } else {
                    return false;
                }
            },
            // This should be for APPROVE (BLAP)
            canApprove() {
                if (!this.order) {
                    return true;
                } else if (this.order && approved) {
                    return true;
                } else if (
                    this.user.permissions.find(
                        (perm) => perm.name == "can_review_invoices",
                    )
                ) {
                    return true;
                } else {
                    return false;
                }
            },
            orderCodes() {
                // Need to map code id to its code type
                // so it will be easier to remove specific code
                // e.g.
                // const { activity, ...codes } = orderCodes
                // const ids = Object.values(codes)
                // activity type chained params = { ids, type: 'ACTIVITY' }
                const codes = {};

                if (this.form.orderType) {
                    codes["ORDERTYPE"] = this.form.orderType;
                }

                if (this.form.subType) {
                    codes["ACTIVITYTYPE"] = this.form.subType;
                }

                if (this.form.problemCode) {
                    codes["PROBLEM"] = this.form.problemCode;
                }

                if (this.activityTypeId) {
                    codes["ACTIVITY"] = this.activityTypeId;
                }

                if (this.assetTypeId) {
                    codes["ASSET"] = this.assetTypeId;
                }

                return codes;
            },
            orderPriorityDependencies() {
                // Reminder: we watch this computed property to know when
                // it's time to update the "priority" options available.
                const dependencies = [this.form.orderType, this.form.subType];

                if (this.form.problemCode) {
                    dependencies.push(this.form.problemCode);
                }

                return dependencies;
            },
            priorityText() {
                const vm = this;
                const code = this.orderPriorities.find((priorityCode) => {
                    return vm.form.priority == priorityCode.id;
                });
                return code ? code.name : "";
            },
            orderLocation() {
                if (this.form.address_latitude && this.form.address_longitude) {
                    return {
                        lat: this.form.address_latitude,
                        lng: this.form.address_longitude,
                    };
                }
                return null;
            },
            activityTypeIsDisabled() {
                return this.orderIsReactive || !this.activityTypeParentId
                    ? true
                    : false;
            },
        },
        async mounted() {
            /**
             * TODO:
             * Refactor async calls that need to happen on mount
             * into a single promise so that we can know when
             * the UI is ready for us to update all select
             * dropdowns that get populated using AJAX.
             *
             * E.g.
             * this.getRouteData().then(data => {
             *   // ready to set default orderType
             *   // ready to set default contractor
             *   // ready to set issuedBy firm etc.
             * });
             *
             * This will avoid race conditions when a select
             * dropdown's value depends on multiple others.
             * E.g. the contractor firm <select> should
             * only default to first item if only one
             * option is available AND there is no
             * parent order data available etc.
             */
            // Fetch orderType code options on load
            // this.getAsset();
            const vm = this;
            this.$store.dispatch("routeLoading");

            await vm.getRouteData().then((data) => {
                vm.contracts = data.contracts;
                if (this.parentOrder) {
                    // HACK: we can't set form.orderType value right now
                    // since we need to wait for multiple watch events.
                    // (and we actually need the orderType ID value)
                    this.next_order_type = "PLANNED";
                    this.form.contract_id = this.parentOrder.contract_id;
                    this.form.contractor = this.parentOrder.firm.id;
                    this.form.address = this.parentOrder.address;
                    this.form.location_asset_id =
                        this.parentOrder.location_asset_id;
                    this.form.parentWO = this.parentOrder.orderId;
                    this.form.address_latitude =
                        this.parentOrder.loggedLat ||
                        this.form.address_latitude;
                    this.form.address_longitude =
                        this.parentOrder.loggedLng ||
                        this.form.address_longitude;
                    this.form.region = this.parentOrder.region
                        ? this.parentOrder.region.id
                        : this.form.region;
                }
            });
            // .finally(() => {
            //   this.$store.dispatch('routeLoading', false);
            // });
            /*
            this.codeService.all({ type: 'ORDERTYPE' }).then(data => {

            // let orderTypes = JsonDenormalizer.denormalize(data);
            // orderTypes = orderTypes.filter(code => {
            //   return (['PLANNED', 'REACTIVE'].indexOf(code.code.toUpperCase()) >= 0)
            //     ? true
            //     : false;
            // });
            // vm.orderTypes = orderTypes;

            // Now that we have orderType codes available:
            if (this.parentOrder) {
                // HACK: we can't set form.orderType value right now
                // since we need to wait for multiple watch events.
                // (and we actually need the orderType ID value)
                this.next_order_type = "PLANNED";
                this.form.contractor = this.parentOrder.firm.id;
                this.form.address = this.parentOrder.address;
                this.form.parentWO = this.parentOrder.orderId;
                this.form.address_latitude = this.parentOrder.loggedLat || this.form.address_latitude;
                this.form.address_longitude = this.parentOrder.loggedLng || this.form.address_longitude;
                this.form.region = this.parentOrder.region ? this.parentOrder.region.id : this.form.region;
            }
            });
            */
            // This will be handled by base select
            // let issuedBy = await this.$refs.issuedBy.fetchOptions();
            // if (issuedBy.length == 1) {
            //   this.form.issuingOrganization = issuedBy[0].id;
            // }
            // let issuedTo = await this.$refs.issuedTo.fetchOptions();
            // if (issuedTo.length == 1 && !this.form.contractor) {
            //   this.form.contractor = issuedBy[0].id;
            // }

            // Preselect Issued By
            // this.form.issuingOrganization = this.user.firmId;
            // Preselect Managed By
            // this.form.manager = this.user.id;

            this.activityOwnerId = this.user.firmId;

            // Pre-populate edit form
            if (this.$route.params.id) {
                await this.populateForm();
            }

            this.$store.dispatch("routeLoading", false);

            // EventUtil.$on("responseError", this.onSubmitFail);
        },
        beforeDestroy() {
            // EventUtil.$off("responseError", this.onSubmitFail);
        },
        watch: {
            "$route.params.id"() {
                this.populateForm();
            },
            contractsGiven: function (next) {
                if (next.length === 1) {
                    this.$set(this.form, "contract_id", next[0].id);
                }
            },
            "form.contract_id": function (next, from) {
                const contract = this.contracts.find((c) => c.id == next);
                this.$set(
                    this.$data.form,
                    "contractor",
                    contract ? contract.contractor_firm_id : null,
                );
                this.$set(
                    this.$data.form,
                    "issuingOrganization",
                    contract ? contract.contractee_firm_id : null,
                );
                // this.orderTypeValue = null;
                // this.getCodeChainStartValue(next)
                //   .then(value => {
                //     this.orderTypeValue = value;
                //     this.getCodeService();
                //   });
                this.getCodeService();
                this.$nextTick(() => {
                    this.$refs.selectLocationAsset.fetchOptions();
                });
            },
            "form.orderType": function (next, from) {
                const vm = this;
                vm.form.problem_code_id = "";
                vm.activityTypeId = "";
                vm.activityTypes = [];
                vm.form.subType = "";
                if (next) {
                    vm.codesBusy = true;
                    vm.getActivityTypeCodes(next)
                        .then((codes) => {
                            vm.activityTypes = codes;
                            // Auto-select if only a single option is available.
                            if (codes.length == 1) {
                                vm.form.subType = codes[0].id;
                            }
                            vm.codesBusy = false;
                        })
                        .catch((err) => {
                            vm.codesBusy = false;
                        });
                }
            },
            "form.subType": function (next, from) {
                const vm = this;

                // Update (3/7/20): subType is not a code string anymore
                // Moved to top. Activity type is not being disabled if subType is set to null (Please select).
                // Need to execute even if subType doesn't have value.
                // For Activity Type Fields
                /* let selectedType = vm.activityTypes.find(code => code.name == vm.form.subType)
                vm.activityTypeParentId = selectedType ? selectedType.id : null; */
                vm.activityTypeParentId = next;
                vm.activityTypeId = null;
                vm.assetTypeId = null;
                vm.asset = null;

                if (!next) {
                    vm.problemCodes = [];
                    vm.form.subType = "";
                    vm.form.problemCode = "";
                } else {
                    vm.codesBusy = true;
                    vm.getProblemCodes(next)
                        .then((codes) => {
                            vm.problemCodes = codes;
                            vm.codesBusy = false;
                        })
                        .catch((err) => {
                            vm.codesBusy = false;
                        });

                    vm.$nextTick(() => {
                        vm.$refs.activityTypeId.fetchOptions();
                        vm.$refs.assetTypeId.fetchOptions();
                    });
                }
            },
            "form.problemCode": function (val) {
                if (val) {
                    this.$nextTick(() => {
                        this.$refs.activityTypeId.fetchOptions();
                    });
                }
            },
            "form.contractor"() {
                this.calculateSla();

                if (
                    this.form.issuingOrganization != this.form.contractor ||
                    this.form.contractor != this.user.firm.id
                ) {
                    this.form.assignedTo = null;
                }
            },
            "form.priority"() {
                this.calculateSla();
            },
            "form.region"() {
                this.calculateSla();
            },
            "form.issuingOrganization"(id) {
                this.form.manager = id == this.user.firmId ? this.user.id : "";

                if (
                    this.form.issuingOrganization != this.form.contractor ||
                    this.form.contractor != this.user.firm.id
                ) {
                    this.form.assignedTo = null;
                }

                UserService.all({
                    firmId: this.form.issuingOrganization,
                    filter_by: "first_name",
                    archived: false,
                }).then((response) => {
                    this.manager = JsonDenormalizer.denormalize(response);
                });
                // this.getOrderType(id)

                if (id) {
                    this.$nextTick(() => {
                        this.$refs.selectActivityOwner.fetchOptions();
                    });
                }

                // 26-04-22 - Fix - clears out form.contractor value
                // this.$nextTick(() => {
                //   this.$refs.issuedTo.fetchOptions();
                // });

                this.$nextTick(() => {
                    this.$refs.selectTags.fetchOptions();
                });
            },
            "form.location_asset_id"(newVal) {
                console.log("locationAssetId", newVal);
                if (newVal) {
                    this.fetchLocationAssetAddress(newVal);
                }
            },
            activityTypeId(id) {
                if (id == "") this.activityTypeId = null;

                // Why does it only fetches once?
                // if(this.assetTypeId == null){
                this.$nextTick(() => {
                    this.$refs.assetTypeId.fetchOptions();
                });
                // }

                this.populateLocationAssetByAsset();
            },
            assetTypeId(id) {
                if (id == "") this.assetTypeId = null;

                // Why does it only fetches once?
                // if(this.activityTypeId == null){
                this.$nextTick(() => {
                    this.$refs.activityTypeId.fetchOptions();
                });
                // }
            },
            orderPriorityDependencies(values) {
                const vm = this;
                let selected_ids = values.filter(Boolean);
                if (selected_ids.length === values.length) {
                    // Good, the user has selected IDs for all the declared dependencies
                    vm.codesBusyPriority = true;
                    vm.form.priority = "";
                    vm.codeService
                        .childIntersection({
                            ids: selected_ids,
                            type: "orderPriority",
                            // firm_id: this.user.firmId,
                            contract_id: this.form.contract_id,
                        })
                        .then((data) => {
                            let codes = JsonDenormalizer.denormalize(data);
                            vm.orderPriorities = codes;
                            // Auto-select if only a single option is available.
                            if (codes.length == 1) {
                                vm.form.priority = codes[0].id;
                            }
                        })
                        .finally(() => {
                            vm.codesBusyPriority = false;
                        });
                } else {
                    vm.orderPriorities = [];
                    vm.form.priority = "";
                }
            },
            asset(value) {
                console.log(value);
            },
        },
        methods: {
            sample(place) {
                // console.log(place);
                this.place = place;
            },
            async populateForm() {
                this.$store.dispatch("routeLoading", true);
                this.order = await OrderService.findOrderById(
                    this.$route.params.id,
                    {
                        includes:
                            "operations,operations.asset,operations.asset.code,region,locationAsset",
                    },
                ).then((response) => JsonDenormalizer.denormalize(response));
                if ((this.order.operations || []).length > 0) {
                    this.operation = this.order.operations[0];
                }
                console.log(this.order, this.operation);

                let form = {
                    contract_id: this.order.contract_id,
                    manager: this.order.managed_by,
                    orderId: this.order.orderId,
                    orderType: this.order.order_type_id || "",
                    subType: this.order.order_subtype_id || "",
                    priority: "", // to be collected later
                    address: this.order.address || "",
                    location_asset_id: this.order.location_asset_id || "",
                    problemCode: this.order.problem_code_id || "",
                    workDescription: this.order.workDescription || "",
                    reference: this.order.supplierOrderId || "",
                    assignedTo: this.order.assigned_to || null,
                    parentWO: this.order.parentOrder || "",
                    duplicateWO: this.order.duplicateOf || "",
                    address_latitude: this.order.loggedLat || 0,
                    address_longitude: this.order.loggedLng || 0,
                    region: this.order.region ? this.order.region.id : "",
                    // Operations
                    activityTypeId:
                        this.operation && this.operation.activity_code_id
                            ? this.operation.activity_code_id
                            : null,
                    activityOwnerId:
                        this.operation && this.operation.ownerFirmId
                            ? this.operation.ownerFirmId
                            : null,
                    asset:
                        this.operation && this.operation.asset
                            ? this.operation.asset
                            : null,
                    assetTypeId:
                        this.operation &&
                        this.operation.asset &&
                        this.operation.asset.code
                            ? this.operation.asset.code.id
                            : null,
                };
                console.log(JSON.parse(JSON.stringify(form)));
                const operationFields = [
                    "activityTypeId",
                    "asset",
                    "assetTypeId",
                    "activityOwnerId",
                ];

                // Populate fields (dependent)
                // Fields to be populated in specific order
                // const fields = [
                //   "contract_id",
                //   "orderType",
                //   "subType",
                //   "problemCode",
                //   "priority",
                //   "activityTypeId",
                //   "asset",
                //   "assetTypeId",
                //   "region",
                //   "address",
                //   "workDescription",
                //   "activityOwnerId",
                //   "assignedTo",
                //   "reference"
                // ];
                const fields = [
                    "contract_id",
                    "orderType",
                    "subType",
                    "problemCode",
                    "priority",
                    "activityTypeId",
                    "asset",
                    "assetTypeId",
                ];
                for (const field of fields) {
                    let value = form[field] || "";
                    // Special cases
                    if (field == "priority") {
                        // Get priority id (priority stored in order is the priority text (name))
                        const priorityCode = this.orderPriorities.find(
                            (v) => v.name == this.order.priority,
                        );
                        if (priorityCode) {
                            value = priorityCode.id;
                        }
                    }
                    // Populate field
                    // Some fields (mostly operations) are not part of the form object
                    if (operationFields.includes(field)) {
                        this[field] = value;
                    } else {
                        this.form[field] = value;
                    }
                    // Wait for field ready
                    await new Promise((resolve) => {
                        setTimeout(() => resolve(), 2000);
                    });
                    delete form[field];
                }
                console.log(JSON.parse(JSON.stringify(form)));
                // Populate remaining fields
                for (const field of Object.keys(form)) {
                    let value = form[field] || "";
                    // Special cases
                    if (field == "location_asset_id") {
                        this.onAssetModalSelectLocationAsset(
                            this.order.locationAsset,
                        );
                    }
                    // Populate field
                    // Some fields (mostly operations) are not part of the form object
                    if (operationFields.includes(field)) {
                        this[field] = value;
                    } else {
                        this.form[field] = value;
                    }
                }
                this.$store.dispatch("routeLoading", false);
            },
            getRouteData() {
                const vm = this;
                return new Promise((resolve, reject) => {
                    let data = {
                        contracts: [],
                    };
                    Promise.all([
                        vm.getContracts({
                            includes: "contractor,attributes",
                            contractee_firm_id:
                                this.$store.state.Auth.user.firmId,
                            permissions: ["contractee can create orders"],
                        }),
                        vm.getContracts({
                            includes: "contractor,attributes",
                            contractor_firm_id:
                                this.$store.state.Auth.user.firmId,
                            permissions: ["contractor can create orders"],
                        }),
                        // vm.getContracts({
                        //   includes: 'contractor,attributes',
                        //   contractor_relationship: 'vendor',
                        //   contractee_permissions: ['can issue orders'],
                        //   firm_firm_permissions: ['can be issued orders'],
                        //   contractee_firm_id: this.$store.state.Auth.user.firmId,
                        // })
                    ])
                        .then((all) => {
                            const givenContracts = all[0];
                            const contracts = all[1];
                            data.contracts = _.unionBy(
                                givenContracts,
                                contracts,
                                "id",
                            );
                            resolve(data);
                        })
                        .catch((err) => {
                            reject(err);
                        });
                });
            },
            getContracts(params) {
                return new Promise((resolve, reject) => {
                    ContractService.all(params)
                        .then((res) => {
                            resolve(JsonDenormalizer.denormalize(res));
                        })
                        .catch((err) => {
                            reject(err);
                        });
                });
            },
            getCodeChainStartValue(contract_id) {
                if (!contract_id) {
                    return Promise.resolve(false);
                } else {
                    let orderTypeValue = null;
                    if (this.contractSelected && this.contractSelected.id) {
                        let attribute = this.contractSelected.attributes.find(
                            (attr) => {
                                return (
                                    attr.code ==
                                    "[SYSTEM][ORDER][CODE_CHAIN][START]"
                                );
                            },
                        );
                        if (attribute) orderTypeValue = attribute.value;
                    }
                    return Promise.resolve(orderTypeValue);
                }
            },
            transformedData(status = null) {
                let data = {
                    // orderId: this.form.orderId,
                    contract_id: this.form.contract_id,
                    firm_id: this.form.contractor,
                    place_id: this.form.place,
                    region_tag_id: this.form.region,
                    priority: this.priorityText, // yes, still using the text instead of ID
                    address: this.form.address,
                    location_asset_id: this.form.location_asset_id,
                    problem_code_id: this.form.problemCode,
                    workDescription: this.form.workDescription,
                    supplierOrderId: this.form.reference,
                    claimId: this.form.claimPeriod,
                    assigned_to: this.form.assignedTo,
                    managed_by: this.form.manager,
                    parentOrder: this.form.parentWO,
                    duplicateOf: this.form.duplicateWO,
                    on_hold: this.form.onHold,
                    further_work: this.form.furtherWorkRequired,
                    return_to_site: this.form.returnToSite,
                    big_storm: this.form.stormEvent,
                    no_survey: this.form.notSurveyed,
                    surcharge_manhole: this.form.manholeSurcharged,
                    status: status || undefined,
                    // releaseDate and lastUpdated are generated in the API
                    // releaseDate: null,
                    // lastUpdated: null,
                    created_by: this.user.id,
                    created_by_firm_id:
                        this.form.issuingOrganization || this.user.firm.id,
                    logged_lat: this.form.address_latitude,
                    logged_lng: this.form.address_longitude,
                    requiredStart: this.form.expectedStart
                        ? moment(this.form.expectedStart)
                              .tz(moment.tz.guess())
                              .format()
                        : null,
                    requiredFinish: this.form.expectedFinish
                        ? moment(this.form.expectedFinish)
                              .tz(moment.tz.guess())
                              .format()
                        : null,
                };

                // There are parts of the application where orderType and activityType are still being used
                const orderType = this.orderTypes.find(
                    (type) => type.id == this.form.orderType,
                );
                const activityType = this.activityTypes.find(
                    (type) => type.id == this.form.subType,
                );

                data = {
                    ...data,
                    orderType: orderType ? orderType.code : null,
                    activityType: activityType ? activityType.name : null,
                    order_type_id: this.form.orderType,
                    order_subtype_id: this.form.subType,
                };

                return data;
            },
            create() {
                return this.orderService.create(this.transformedData());
            },
            update(status) {
                return this.orderService.update(
                    this.order.id,
                    this.transformedData(status),
                );
            },
            propose() {
                return this.orderService.propose(this.order.id);
            },
            createOperation() {
                return this.orderOperationService
                    .create({
                        orderId: this.order.id,
                        activityCodeId: this.activityTypeId,
                        ownerFirmId: this.activityOwnerId,
                        // locationId: this.assetTypeId !== null && this.assetTypeId !== 'false' ? this.assetTypeId : null,
                        locationId:
                            this.assetTypeId && this.assetType
                                ? this.assetType.code
                                : null,
                        operationId: "0010",
                        assetId: this.asset ? this.asset.id : undefined,
                    })
                    .then((response) => JsonDenormalizer.denormalize(response));
            },
            async getAsset() {
                await AssetService.getAsset({
                    firm_id: this.user.firm.id,
                }).then((response) => {
                    this.assets = JsonDenormalizer.denormalize(response);
                });
                // await AssetService.all().then(response => {
                //   this.assets = JsonDenormalizer.denormalize(response);
                // });
            },
            updateOperation() {
                return this.orderOperationService
                    .update(this.operation.id, {
                        orderId: this.order.id,
                        activityCodeId: this.activityTypeId,
                        ownerFirmId: this.activityOwnerId,
                        // locationId: this.assetTypeId,
                        locationId:
                            this.assetTypeId && this.assetType
                                ? this.assetType.code
                                : null,
                        assetId: this.asset ? this.asset.id : undefined,
                    })
                    .then((response) => JsonDenormalizer.denormalize(response));
            },
            async validateCodes() {
                if (Object.keys(this.orderCodes).length) {
                    try {
                        await this.codeService.chained({
                            ids: this.getOrderCodeIds(),
                            contract_id: this.form.contract_id,
                        });
                    } catch (err) {
                        throw err;
                    }
                }

                return;

                // Collect codes to be validated
                const codes = [];

                // Get order type id
                const orderTypeCode = this.orderTypes.find((code) => {
                    return (
                        code.code.toUpperCase() ==
                        this.form.orderType.toUpperCase()
                    );
                });
                const orderTypeId = orderTypeCode ? orderTypeCode.id : null;

                if (orderTypeId) {
                    codes.unshift(orderTypeId);
                }

                // Get sub type id
                const activityTypeCode = this.activityTypes.find((code) => {
                    return (
                        code.name.toUpperCase() ==
                        this.form.subType.toUpperCase()
                    );
                });
                const activityTypeId = activityTypeCode
                    ? activityTypeCode.id
                    : null;

                if (activityTypeId) {
                    codes.unshift(activityTypeId);
                }

                // Get problem code id
                // Problem code needs to be validated when order type is REACTIVE
                if (
                    this.form.orderType === "REACTIVE" &&
                    this.form.problemCode
                ) {
                    codes.unshift(this.form.problemCode);
                }

                // Get operation activity type id
                if (this.activityTypeId) {
                    codes.unshift(this.activityTypeId);
                }

                // Get asset code id
                // Asset code needs to be validated when order type is not REACTIVE
                if (this.form.orderType !== "REACTIVE" && this.assetTypeId) {
                    codes.unshift(this.assetTypeId);
                }

                try {
                    await this.codeService.validateAssociations(codes);
                } catch (err) {
                    throw err;
                }
            },
            async draft() {
                this.drafting = true;

                try {
                    await this.validateCodes();

                    const isNew = !this.order;

                    if (this.order) {
                        this.order = await this.update("DRAFT").then(
                            (response) =>
                                JsonDenormalizer.denormalize(response),
                        );
                        // this.operation = await this.updateOperation();
                    } else {
                        this.order = await this.create().then((response) =>
                            JsonDenormalizer.denormalize(response),
                        );
                        // if (this.activityTypeId) {
                        //   this.operation = await this.createOperation(this.order);
                        // }
                    }

                    if (this.operation) {
                        this.operation = await this.updateOperation();
                    } else {
                        if (this.activityTypeId) {
                            this.operation = await this.createOperation(
                                this.order,
                            );
                        }
                    }

                    this.$buefy.toast.open({
                        message: "Draft has been saved.",
                        type: "is-info",
                        position: "is-top-right",
                    });

                    if (isNew) {
                        // this.$router.push({ name: 'order-update', params: { id: this.order.id }});
                        // window.location.replace(`/orders/${this.order.id}/update`);
                        window.history.replaceState(
                            null,
                            null,
                            `/orders/${this.order.id}/update`,
                        );
                    }
                } catch (err) {}

                this.drafting = false;
            },
            async submit() {
                this.region_error =
                    this.$refs.selectTags.options.length && !this.form.region;
                this.activity_type_error = !this.activityTypeId;
                this.asset_error = this.isAssetRequired() && !this.asset;
                this.asset_type_error =
                    this.isAssetTypeRequired() && !this.assetTypeId;
                if (
                    this.region_error ||
                    this.activity_type_error ||
                    this.asset_error ||
                    this.asset_type_error
                ) {
                    return false;
                }
                this.activity_type_error = false;
                this.asset_type_error = false;
                this.region_error = false;
                this.asset_error = false;
                this.submitting = true;

                try {
                    await this.validateCodes();

                    let message = "";

                    // Create/Update order
                    if (this.order) {
                        this.order = await this.update("DRAFT").then(
                            (response) =>
                                JsonDenormalizer.denormalize(response),
                        );
                    } else {
                        // 2024-01-30 - Create order as DRAFT then PROPOSED/APPROVE after the operation is created
                        // Create order (DRAFT)
                        this.order = await this.create().then((response) =>
                            JsonDenormalizer.denormalize(response),
                        );
                        // Update URL
                        window.history.replaceState(
                            null,
                            null,
                            `/orders/${this.order.id}/update`,
                        );
                    }

                    // Create/Update operation
                    if (this.operation) {
                        this.operation = await this.updateOperation();
                    } else {
                        if (this.activityTypeId) {
                            this.operation = await this.createOperation(
                                this.order,
                            );
                        }
                    }

                    // Approve/Propose order
                    message = await this.propose().then(
                        (response) => response.message,
                    );

                    // Orders Outbound Filter
                    localStorage.setItem("__order_table_source", "outbound");
                    // Redirect
                    this.$router.push({
                        name: "order-list",
                        query: { id: this.order.id },
                    });

                    this.$buefy.toast.open({
                        message,
                        type: "is-info",
                        position: "is-top-right",
                    });
                } catch (err) {
                    console.error(err);
                }

                this.submitting = false;
            },

            // async onSubmitFail(response) {
            //   // Draft order is created on failed submissions
            //   if (response.order) {
            //     this.order = JsonDenormalizer.denormalize(response.order);
            //     // Continue to create/update operation
            //     if (this.operation) {
            //       this.operation = await this.updateOperation();
            //     } else {
            //       if (this.activityTypeId) {
            //         this.operation = await this.createOperation(this.order);
            //       }
            //     }
            //     // Update URL
            //     window.history.replaceState(null, null, `/orders/${this.order.id}/update`);
            //   }
            // },

            /* async createOperation(order){

            if(this.activityTypeId && this.assetTypeId){

                const form =  {
                        orderId: this.order.id,
                        activityCodeId: this.activityTypeId,
                        ownerFirmId: this.activityOwnerId,
                        locationId: this.assetTypeId,
                        operationId: '0010',
                        };
                const operation = await this.orderOperationService.create(form);

            }

            }, */
            getActivityTypeCodes(orderType) {
                // Update (3/7/20): orderType is not a code string anymore
                // Currently orderType is a code string so we need to find underlying code manually.
                const vm = this;
                /* const orderTypeCode = this.orderTypes.find(code => {
                return (code.code.toUpperCase() == orderType.toUpperCase());
                });
                const orderTypeId = orderTypeCode
                ? orderTypeCode.id
                : null; */
                return new Promise((resolve, reject) => {
                    if (!orderType) {
                        return resolve([]);
                    }
                    vm.codeService
                        .chained({
                            ids: this.getOrderCodeIds("ACTIVITYTYPE"),
                            type: "ACTIVITYTYPE",
                            contract_id: this.form.contract_id,
                        })
                        .then((data) => {
                            let codes = JsonDenormalizer.denormalize(data);
                            return resolve(codes);
                        })
                        .catch((err) => {
                            return reject(err);
                        });
                });
            },
            getActivityTypeText(code) {
                const map = {
                    REACTIVE: "REACTIVE",
                    PREVENTIVE: "PREVENTIVE",
                    PLANNED: "PLANNED",
                    "MINOR CAPITAL": "MINOR CAPITAL",
                };
                return map[code.name] ? map[code.name] : code.name;
            },
            getProblemCodes(activityType) {
                // Update (3/7/20): activityType is not a code string anymore
                // Currently activityType is a code string so we need to find underlying code manually.
                const vm = this;
                /* const activityTypeCode = this.activityTypes.find(code => {
                return (code.name.toUpperCase() == activityType.toUpperCase());
                });
                const activityTypeId = activityTypeCode
                ? activityTypeCode.id
                : null; */
                return new Promise((resolve, reject) => {
                    if (!activityType) {
                        return resolve([]);
                    }
                    vm.codeService
                        .chained({
                            ids: this.getOrderCodeIds("PROBLEM"),
                            type: "PROBLEM",
                            contract_id: this.form.contract_id,
                        })
                        .then((data) => {
                            let codes = JsonDenormalizer.denormalize(data);
                            return resolve(codes);
                        })
                        .catch((err) => {
                            return reject(err);
                        });
                });
            },
            getOrders(search, autocomplete) {
                if (this.autocomplete[autocomplete].timeout) {
                    clearTimeout(this.autocomplete[autocomplete].timeout);
                }

                this.autocomplete[autocomplete].timeout = setTimeout(
                    async () => {
                        this.autocomplete[autocomplete].loading = true;

                        try {
                            const response = await this.orderService.all({
                                search,
                            });

                            this.autocomplete[autocomplete].data =
                                JsonDenormalizer.denormalize(response);
                        } catch (err) {}

                        this.autocomplete[autocomplete].loading = false;
                    },
                    500,
                );
            },
            onInput(field, val) {
                this.form[field] = val;
            },
            onChange(field, val) {
                // alert(field);
                // alert(val);
                // alert();
                this[field] = val;
                // this.form[field] = val;
            },
            ordersPage() {
                this.$router.replace({ name: "order-list" });
            },
            getAddressData(addressData) {
                let street_number = addressData.street_number
                    ? addressData.street_number
                    : "";
                let route = addressData.route ? addressData.route : "";
                let locality = addressData.locality ? addressData.locality : "";
                let postal_code = addressData.postal_code
                    ? addressData.postal_code
                    : "";
                let administrative = addressData.administrative_area_level_1
                    ? addressData.administrative_area_level_1
                    : "";
                let country = addressData.country ? addressData.country : "";

                this.form.address =
                    street_number +
                    " " +
                    route +
                    " " +
                    locality +
                    " " +
                    postal_code +
                    " " +
                    administrative +
                    " " +
                    country;
                this.form.address_latitude = addressData.latitude;
                this.form.address_longitude = addressData.longitude;
            },

            sample() {
                var myLatlng = new google.maps.LatLng(
                    parseFloat(position.coords.latitude),
                    parseFloat(position.coords.longitude),
                );
                this.$refs.addressAutoComplete.updateCoordinates(myLatlng);
            },

            getGPSLocation() {
                if (navigator.geolocation) {
                    // Get Current address position
                    navigator.geolocation.getCurrentPosition(
                        (position) => {
                            // Format LatLng
                            var myLatlng = new google.maps.LatLng(
                                parseFloat(position.coords.latitude),
                                parseFloat(position.coords.longitude),
                            );
                            // Call method in component
                            // console.log(myLatlng);
                            this.$refs.addressAutoComplete.updateCoordinates(
                                myLatlng,
                            );
                        },
                        (error) => {
                            alert(
                                "Error Code: " +
                                    err.code +
                                    " Error Message: " +
                                    err.message,
                            );
                        },
                        {
                            timeout: 5000,
                            maximumAge: 0,
                            enableHighAccuracy: true,
                        },
                    );
                    // // Get Current address position
                    // navigator.geolocation.getCurrentPosition(location => {
                    //   // console.log('asdasdas',location)
                    //   // Format LatLng
                    //   var myLatlng = new google.maps.LatLng(
                    //     parseFloat(location.coords.latitude),
                    //     parseFloat(location.coords.longitude)
                    //   );
                    //   // Call method in component
                    //   this.$refs.addressAutoComplete.updateCoordinates(myLatlng);
                    // });
                } else {
                    alert("Geolocation is not supported by this browser.");
                }
            },
            async calculateSla() {
                if (this.form.contractor && this.form.priority) {
                    const data = await this.orderService
                        .calculateSla({
                            contract_id: this.form.contract_id,
                            firm_id: this.form.contractor,
                            priority_code_id: this.form.priority,
                            // region_tag_id: this.form.region,
                            release_date: moment().format(
                                "YYYY-MM-DD HH:mm:ss",
                            ),
                        })
                        .then((response) => response.data.data);

                    this.form.expectedStart = data.result.required_start
                        ? new Date(
                              moment(data.result.required_start).format(
                                  "MM/DD/YYYY HH:mm:ss",
                              ),
                          )
                        : null;
                    this.form.expectedFinish = data.result.required_finish
                        ? new Date(
                              moment(data.result.required_finish).format(
                                  "MM/DD/YYYY HH:mm:ss",
                              ),
                          )
                        : null;
                    this.serviceLevel = data.service_level;
                }
            },
            getOrderCodeIds(type = "") {
                const { [type]: excluded, ...codes } = this.orderCodes;
                return Object.values(codes);
            },
            async getOrderType() {
                await FirmService.getHasAtribute({
                    id: this.form.issuingOrganization,
                }).then((response) => {
                    this.orderTypeValue = null;
                    if (response != null) {
                        this.orderTypeValue = response.pivot.value;
                    }
                });
                this.getCodeService();
            },
            async getCodeService() {
                // let orderType = this.orderTypeValue;
                this.orderTypes = [];
                this.form.orderType = "";
                // if (orderType) {
                await this.codeService
                    .all({
                        type: "orderType",
                        contract_id: this.form.contract_id,
                        firm_id: this.form.contract_id
                            ? undefined
                            : this.user.firmId,
                    })
                    .then((data) => {
                        let orderTypes = JsonDenormalizer.denormalize(data);
                        // orderTypes = orderTypes.filter(code => {
                        //   return (['PLANNED', 'REACTIVE'].indexOf(code.code.toUpperCase()) >= 0)
                        //     ? true
                        //     : false;
                        // });
                        this.orderTypes = orderTypes;

                        // Hack to deal with knowing the order type to choose ahead of time
                        // (e.g. when this is a suborder, we know we should set PLANNED)
                        if (this.next_order_type) {
                            const nextOrderType = orderTypes.find((t) => {
                                return (
                                    t.code.toUpperCase() ===
                                    this.next_order_type.toUpperCase()
                                );
                            });
                            if (nextOrderType) {
                                this.form.orderType = nextOrderType.id;
                            }
                            this.next_order_type = false;
                        }
                    });
                // }
            },
            async populateLocationAssetByAsset() {
                if (this.asset && this.activityTypeId) {
                    const calloutCode = this.$refs.activityTypeId.options.find(
                        (option) => {
                            return (
                                option.code.toUpperCase() === "CALL" ||
                                option.code.toUpperCase() === "CALLOUT"
                            );
                        },
                    );
                    if (
                        !calloutCode ||
                        (calloutCode && this.activityTypeId != calloutCode.id)
                    ) {
                        const asset = await AssetService.show(this.asset.id, {
                            includes: "site",
                        }).then((response) =>
                            JsonDenormalizer.denormalize(response),
                        );
                        this.onAssetModalSelectLocationAsset(
                            asset.site || null,
                        );
                    } else {
                        this.onAssetModalSelectLocationAsset(null);
                    }
                }
            },
            onAssetModalSelect(asset) {
                // console.log(asset);
                // var myLatlng = new google.maps.LatLng(
                //   parseFloat(asset.assetNodes[0].latitude),
                //   parseFloat(asset.assetNodes[0].longitude)
                // );
                // this.$refs.addressAutoComplete.updateCoordinates(myLatlng);

                this.asset = asset;
                // this.assetTypeId = asset && asset.code ? asset.code.id : null;
                if (asset && asset.code) {
                    this.assetTypeId = asset.code.id;
                }

                this.populateLocationAssetByAsset();
            },
            onAssetModalSelectLocation(event) {
                this.form.address = event.address;
                this.form.address_latitude = event.coordinates.lat;
                this.form.address_longitude = event.coordinates.lng;
            },
            onAssetModalSelectLocationAsset(asset) {
                this.locationAsset = asset;
                this.form.location_asset_id = asset ? asset.id : "";
            },
            isAssetRequired() {
                // We need to use a method instead of a computed property because
                // we rely on checking if a child component has options loaded.
                // ($refs are not reactive in vue so we need a runtime check)
                // See more here: https://github.com/vuejs/vue/issues/3842
                let is_required = false;
                const activityType = this.activityTypes.find(
                    (type) => type.id == this.form.subType,
                );
                if (
                    !this.$refs.assetTypeId ||
                    this.$refs.assetTypeId.options.length !== 0
                    // && (
                    //   activityType && activityType.code.toUpperCase() !== 'PRV'
                    // )
                ) {
                    is_required = true;
                }
                return is_required;
            },
            isAssetTypeRequired() {
                // We need to use a method instead of a computed property because
                // we rely on checking if a child component has options loaded.
                // ($refs are not reactive in vue so we need a runtime check)
                // See more here: https://github.com/vuejs/vue/issues/3842
                return !this.$refs.assetTypeId ||
                    this.$refs.assetTypeId.options.length !== 0
                    ? true
                    : false;
            },
            onActivityTypeOptionsUpdated(payload) {
                // https://trello.com/c/3mSSOyO2/1597
                const vm = this;
                const { options } = payload;
                // This component is creating a new order _and_ its first operation
                // so we can assume that the operation in question will be 0010.
                if (vm.orderIsReactive) {
                    // 'CALLOUT' hack for small waters - there should only be one or the other available in dropdown
                    const calloutCode = options.find((option) => {
                        return (
                            option.code.toUpperCase() === "CALL" ||
                            option.code.toUpperCase() === "CALLOUT"
                        );
                    });
                    if (calloutCode) {
                        vm.$nextTick(() => {
                            vm.activityTypeId = calloutCode.id;
                        });
                    }
                }
            },
            fetchLocationAssetAddress(assetId) {
                // Use the 'show' method to fetch details of the selected locationAsset
                this.assetService
                    .show(assetId)
                    .then((response) => {
                        const assetAddress = response.data.attributes.address;
                        this.$set(this.form, "address", assetAddress);

                        const assetNodes = response.included.find(
                            (item) => item.type === "asset-nodes",
                        );

                        const locationAssetLat = assetNodes.attributes.latitude;
                        const locationAssetLon =
                            assetNodes.attributes.longitude;
                        this.$set(
                            this.form,
                            "address_latitude",
                            locationAssetLat,
                        );
                        this.$set(
                            this.form,
                            "address_longitude",
                            locationAssetLon,
                        );
                    })
                    .catch((error) => {
                        console.error(
                            "Error fetching location asset details:",
                            error,
                        );
                        // Handle error, potentially resetting the address field or providing feedback
                    });
            },
        },
    };
</script>

<style lang="scss" scoped>
    .form {
        .scrollable {
            height: calc(100vh - 12rem);
        }
    }

    .detail {
        .scrollable {
            height: calc(100vh - 104px - 1.5rem - 0.85rem - 1.5rem);
        }
    }

    .overlay {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(255, 255, 255, 0.3);
        z-index: 9;
    }

    .field-label .label {
        white-space: normal;
    }
</style>



// WEBPACK FOOTER //
// src/components/pages/Orders/create/full.vue